import { render, staticRenderFns } from "./RecursosHView.vue?vue&type=template&id=1363b89e"
import script from "./RecursosHView.vue?vue&type=script&lang=js"
export * from "./RecursosHView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports